import React, { useContext, useEffect, useRef, useState } from 'react';
import Navigation from '../Navigation/Navigation';
import './Home.css';
import combined from '../../assets/metas.json';
import artists from '../../assets/artists.json';
import { LazyImage } from '../common/LazyImage';
import InfiniteScroll from 'react-infinite-scroll-component';
import { toast } from 'react-toast';
import Web3Ctx from '../Context/Web3Ctx';

import NftCardV2 from '../common/NftCardV2';

import artistAvatar from '../../assets/images/nft-icons/artist-default-avatar.png';
import opensea from '../../assets/images/nft-icons/icon_opensea.png';
import etherscan from '../../assets/images/nft-icons/icon_etherscan.png';
import mag from '../../assets/images/nft-icons/icon_search.png';
import closeX from '../../assets/images/nft-icons/close_button.svg';
import RemoteImage from '../common/RemoteImage';
import Explorer from './Explorer';


const ITEMS_PER_PAGE = 20;

const Home = (props) => {
    const {setThumbnail} = useContext(Web3Ctx);
    const [currentPage,setCurrentPage] = useState(0);
    const [allCards, setAllCards] = useState([]);
    const [theCards, setTheCards] = useState([]);
    const [cardIdInput,setCardIdInput] = useState('');

    const [cardType,setCardType] = useState('all');
    const [artistName, setArtistName] = useState('');
    const [onlyPerfect,setOnlyPerfect] = useState(false);

    const [showExplorer,setShowExplorer]=useState(false);
    
    const [tokenId, setTokenId] = useState(0);
    const [serie, setSerie] = useState('founder');

    



    useEffect(()=>{
            let cards=[];
            
            for(let k=0;k<combined.length;k++){
                cards.push({
                    id: combined[k].id,
                    imgUrl: combined[k].imageURL/* .replace('https://ether-cards.mypinata.cloud/ipfs/QmbkGSyXgthdE7bXA8RUzFxXnR13qQCsk4sBJm4KAFDhwC','http://images.burneth.com') */
                });
            }
            console.log('start rendering',cards.length);
            setAllCards(cards);
    },[]);

    useEffect(()=>{
        console.log('about to load the first batch');

        if(allCards.length>0){
            loadNext();
        }
    },[allCards]);

    useEffect(()=>{

        let serie = props.match.params.series?props.match.params.series:'';
        let id = props.match.params.tokenId?parseInt(props.match.params.tokenId):0;

        
        if(id>9999){
            return;
        }

        if(serie=='founder'){
            
            setTokenId(id);
            setSerie('founder');
            setShowExplorer(true);

        }

    },[props]);



    const loadNext = ()=>{
        let c=[];
        let end = allCards.length<ITEMS_PER_PAGE?allCards.length:ITEMS_PER_PAGE;
        for(let i=0;i<end;i++){
            c.push(allCards[currentPage*ITEMS_PER_PAGE+i]);
        }
        setTheCards(theCards => theCards.concat(c));
        //console.log('C',c);
        setCurrentPage(currentPage+1);
   }


   const handleClick = (idx) => {
        /* window.scrollTo(0,0);*/

        
        props.history.push('/founder/'+combined[idx].id);
        

        
       
   }

   
   //filters 
    const handleCardTypeSelect = (value) => {
        console.log(value);

        setCardType(value);

        combinedFilter(value,artistName,onlyPerfect);
        return;
    }

    const handleArtistSelect = (value) => {

        console.log(value)
        setArtistName(value);

        combinedFilter(cardType,value,onlyPerfect);
        return;
    }

    const handlePerfectChecked = (value) => {
        setOnlyPerfect(value);
        combinedFilter(cardType,artistName,value);
    }


    const combinedFilter = (cardType,artist,perfect)=>{
        
        let s = 0;
        let e= combined.length;
/* 
        switch (cardType){
            case 'creator':
                {
                    s=0;
                    e=10;
                    break;
                }
            case 'og':
                {
                    s=10;
                    e=100;
                    break;
                }
            case 'alpha':
                {
                    s=100;
                    e=1000;
                    break;
                }
            case 'founder':
                {
                    s=1000;
                    e=10000;
                    break;
                }
        }
 */
        let cards=[];
        let layer=[];
        for(let i=s;i<combined.length;i++){

            let res=i;

            let layeredOnly = false;

            if(artist){
                if(combined[i].artist!==artist && combined[i].layerArtist.includes(artist)===false){
                    res=null;
                }else{
                    if(combined[i].artist!==artist){
                        layeredOnly = true;
                    }
                }
            }

            if(res!==null && perfect===true){
                if(combined[i].perfect===false){
                    res=null;
                }
            }

            if(res!==null){

                if(!layeredOnly){
                    cards.push({
                        id: combined[res].id,
                        imgUrl: combined[i].imageURL
                    });
                }else {
                    layer.push({
                        id: combined[i].id,
                        imgUrl: combined[i].imageURL
                    });
                }
            }

        }
        
        setCurrentPage(0);
        setTheCards([]);


        if(layer.length>0){
            setAllCards(cards.concat(layer));
        }else{
            setAllCards(cards);
        }

        window.scrollTo(0,0);
    }


    const showSelectedIds = ()=>{

        if(cardIdInput === ''){
            toast.error('Enter some card IDs. Comma separated list or a range (23-42)');
            return;
        }


        let rawInput = cardIdInput.replace(/ /g,',');

        let idArray = rawInput.split(',');
        
        let cards=[];
        for(let i=0;i<idArray.length;i++){
            let item=idArray[i];
            if(item){
                
                if(item.indexOf('-')>0){
                    let range = item.split('-');
                    if(range[range.length-1]===''){
                        toast.warn('Missing \'to\' param.');
                    }else{

                        let s=parseInt(range[0]);
                        let e=parseInt(range[range.length-1]);

                        if(!isNaN(s) && !isNaN(e)){
                            if(e<s){
                                let t = s;
                                s=e;
                                e=t;
                            }

                            if(s===e){
                                toast.warn('Range '+s+' to '+e+' selected. :)'); 
                            }

                            if(e>9999 || s<0){
                                toast.warn('Out of range.'); 
                            }else{
                                for(let j=s;j<=e;j++){
                                    if(j>combined.length){
                                        return;
                                    }
                                    cards.push({
                                        id: combined[j].id,
                                        imgUrl: combined[j].imageURL
                                    });
                                }
                            }

                        }else{
                            toast.warn('Wrong param format. Range should be like \'23-42\'');
                        }
                    }

                }else{
                    if(!isNaN(parseInt(item))){
                        if(parseInt(item)>=0){
                            if(parseInt(item)>9999){
                                toast.warn('Out of range.'); 
                            }else{
                                if(parseInt(item)>=combined.length){
                                    return;
                                }
                                cards.push({
                                    id: combined[parseInt(item)].id,
                                    imgUrl: combined[parseInt(item)].imageURL
                                });
                            }
                        }else{
                            toast.warn('The card ID must be positive: '+item);
                        }
                    }else{
                        toast.warn('Invalid value: '+item);
                    }
                }
            }
        }

        console.log('filtered',cards.length);
        setCurrentPage(0);
        setTheCards([]);
        setAllCards(cards);
        window.scrollTo(0,0);


        //toast.info('OK. This is under dev. Let\'s try again tomorrow.');
    }

    const handlePrevNextClick =(v)=>{
        console.log('ID',v);
        props.history.push(v);
    }

    return (
        <>
            <Navigation/>
            <div className="container mt-5 h-100 home">
                <div className="filters w-100 mt-0  pt-3 pb-0 ">
                    <div className="content col-md-7 mx-auto ">
                        <div className="row px-2 py-2">
                            <div className="filter-item">
                                <h5>Card Type</h5>
                                <div className="selected-option open">
                                    {cardType==='og'?'OG':cardType==='all'?'All card types':cardType}
                                    <div className="dropdown">
                                        <div className="dd-container">

                                            <ul className="">
                                                <li onClick={()=>handleCardTypeSelect("all")}>All</li>
                                                <li onClick={()=>handleCardTypeSelect("creator")}>Creator</li>
                                                <li onClick={()=>handleCardTypeSelect("og")}>OG</li>
                                                <li onClick={()=>handleCardTypeSelect("alpha")}>Alpha</li>
                                                <li onClick={()=>handleCardTypeSelect("founder")}>Founder</li>
                                            </ul>
                                        
                                        </div>
                                    </div>
                                
                                </div>


                            </div>

                            <div className="filter-item">
                                <h5>Artist</h5>
                                <div className="selected-option open">
                                    {artistName?artistName:'All artists'}
                                    <div className="dropdown">
                                        <div className="dd-container">
                                            <ul className="">
                                            <li onClick={()=>handleArtistSelect('')}>All</li>
                                                {artists.map((i,idx)=>{return(
                                                <li key={'a'+i} onClick={()=>handleArtistSelect(i)}>{i}</li>
                                                )})}
                                            </ul>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="filter-item">
                                <h5>Layers</h5>
                                <div className="selected-option open">
                                    {onlyPerfect?'Perfects only':'All'}
                                    <div className="dropdown">
                                        <div className="dd-container">
                                            <ul className="">
                                                <li onClick={()=>handlePerfectChecked(false)}>All</li>
                                                <li onClick={()=>handlePerfectChecked(true)}>Perfects only</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="filter-item">
                                <div className="id-filter d-flex">
                                    <input type="text" 
                                        className="" 
                                        placeholder="Card IDs"
                                        value = {cardIdInput}
                                        onChange={(e)=>setCardIdInput(e.target.value)}
                                        onKeyUp={(e)=>{if(e.key === "Enter"){showSelectedIds()}}}
                                        />
                                    <button className="ml-auto mr-1" onClick={showSelectedIds}><img src={mag}/></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className="back-top d-md-none d-block"
                    onClick={()=>{
                        if(window){
                            window.scrollTo({top:0,left:0,behavior: 'smooth'});
                        }
                     }
                    }>
                    &#8682;
                </div>


                {theCards.length>0 &&
                    <InfiniteScroll
                    dataLength={theCards.length}
                    next={loadNext}
                    hasMore={currentPage*ITEMS_PER_PAGE<allCards.length}
                    loader={<h4>Loading...</h4>}
                >
                    <div className="row mt-5 mx-0 pt-3 h-100">

                        {theCards.map((v,i)=> {return(
                                <div key={'card-'+i} className="col-md-3">
                                    {v&&<div className="nft-card" onClick={()=>handleClick(i)}>
                                        <LazyImage src={v.imgUrl}/>
                                        <div className="nft-type">
                                            {v.id<10?'CREATOR':v.id<100?'OG':v.id<1000?'ALPHA':'FOUNDER'}
                                        </div>

                                        <div className="info-panel row pl-4 py-2 mx-0">
                                            <div className="col-2 avatar">
                                                <img src={artistAvatar} alt="" />
                                            </div>
                                            <div className="col-10 pl-1 details">
                                                <h5>{combined[i].artist}</h5>
                                                <p className="mb-1">{combined[i].title}</p>
                                                <p className="mb-1"><span className="gray-text">ID:</span> {combined[i].id}</p>
                                            
                                            
                                                <div className="link-panel">
                                                <a href={`https://opensea.io/assets/0x97ca7fe0b0288f5eb85f386fed876618fb9b8ab8/${v.id}`} onClick={(e)=>{e.stopPropagation()}} target="_blank" className="lnk opensea">
                                                    <img src={opensea} alt="opensea link"/>
                                                </a>
                                                <a href={`https://etherscan.io/token/0x97ca7fe0b0288f5eb85f386fed876618fb9b8ab8?a=${v.id}`} onClick={(e)=>{e.stopPropagation()}} target="_blank" className="lnk etherscan">
                                                    <img src={etherscan} alt="etherscan link"/>
                                                </a>
                                            </div>
                                            </div>

                                            
                                        </div>

                                    </div>}
                                </div>

                            );})
                        }

                    </div>
                </InfiniteScroll>}

                {theCards.length===0 && 
                    <div className="row mt-5 pt-3 h-100 text-center">
                        <h5 className="mt-5 w-100">No {onlyPerfect?'perfect ':''}{cardType&&cardType!=='all'?cardType.toUpperCase():''} cards found {artistName?'from '+artistName:''}.</h5>
                    </div>

                }

            </div>

            {showExplorer&&
                <Explorer 
                visible={true}
                tokenId={tokenId}
                serie = {serie}
                onClose = {()=>setShowExplorer(false)}
                onNavigateClick={handlePrevNextClick}
                />}

        </>
    );

}

export default Home;